/**
 * Token management utilities
 * Handles saving, retrieving, and removing JWT tokens from localStorage
 */

const TOKEN_KEY = 'token'
const USER_KEY = 'user_info'

/**
 * Save token to localStorage
 * @param {string} token - JWT token
 */
export function saveToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  }
}

/**
 * Get token from localStorage
 * @returns {string|null} JWT token or null if not found
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * Check if token exists
 * @returns {boolean} True if token exists
 */
export function hasToken() {
  return !!localStorage.getItem(TOKEN_KEY)
}

/**
 * Remove token from localStorage
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

/**
 * Save user information to localStorage
 * @param {object} userInfo - User information object
 */
export function saveUserInfo(userInfo) {
  if (userInfo) {
    localStorage.setItem(USER_KEY, JSON.stringify(userInfo))
  }
}

/**
 * Get user information from localStorage
 * @returns {object|null} User information or null if not found
 */
export function getUserInfo() {
  const userInfoStr = localStorage.getItem(USER_KEY)
  if (!userInfoStr) return null
  try {
    return JSON.parse(userInfoStr)
  } catch (e) {
    console.error('Failed to parse user info:', e)
    return null
  }
}

/**
 * Clear all auth data from localStorage
 */
export function clearAuthData() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
}

export default {
  saveToken,
  getToken,
  hasToken,
  removeToken,
  saveUserInfo,
  getUserInfo,
  clearAuthData
}
